import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Divider,
  Button,
  Stack,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
// import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import AppConfig from "appConfig";
import usePageTitle from "app/pageTitle";
import MDInput from "theme/components/MDInput";

export default function OpsActivitiesPage() {
  const pageTitle = "";
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/ops/${ref}/activities.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setActivities(result.data.data.activities);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  const [search, setSearch] = useState("");

  const filteredTrackers = activities.filter((activity) => {
    const value = search.toLowerCase();

    return activity.title?.toLowerCase().includes(value);
  });
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mt={1} mb={5}>
        <MDBox ml={-2} mb={1} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              onClick={() => navigate(`/ops/workspaces/${ref}`)}
              startIcon={<Icon>west</Icon>}
              color="dark"
            >
              Back
            </Button>
          </MDBox>
        </MDBox>
        <MDBox mb={3}>
          <Card>
            <MDBox p={2}>
              <MDBox
                display="flex"
                justifyContent="space-between"
                px={1}
                mb={2}
                alignItems="center"
              >
                <MDBox>
                  <Icon>assignments</Icon>
                </MDBox>
                <MDBox align="right">
                  <MDTypography variant="h6" fontWeight="bold">
                    Activity Tasks
                  </MDTypography>
                </MDBox>
              </MDBox>
              <MDBox my={2} align="center">
                <MDInput
                  fullWidth
                  label="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mt={0}>
          {activities.length > 0 ? (
            <Stack gap={3}>
              {filteredTrackers.map((activity) => (
                <MDBox
                  onClick={() => {
                    navigate(
                      `/ops/workspaces/activities/${activity.reference}`,
                    );
                  }}
                >
                  <Card>
                    <MDBox px={1.5} py={2}>
                      <MDBox display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography
                            variant="h6"
                            fontSize={16}
                            display="flex"
                            alignItems="center"
                            gap={1}
                          >
                            {/* <Icon color="dark">task</Icon> */}
                            {activity.title}
                          </MDTypography>
                          <MDTypography
                            variant="caption"
                            fontSize={13}
                          >
                            Perform task
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Icon>east</Icon>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              ))}
            </Stack>
          ) : (
            <Card>
              <MDBox align="center" p={2}>
                <MDTypography fontSize={48}>
                  <Icon>warning</Icon>
                </MDTypography>
                <MDTypography variant="body2">
                  No activities configured for this account.
                </MDTypography>
              </MDBox>
            </Card>
          )}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
